<template>
  <app-wrapper>
    <app-header :loan="loan" medium-max-width="max-w-1000">
      <template #navigation>
        <div class="max-w-200">
          <h5 class="font-zen-dots text-white">
            <AppLogo/>
          </h5>
        </div>
      </template>
      <template #top>
        <div class="w-full flex items-center">
          <div class="flex-auto">
            Your desired loan amount
            <h2 class="mb-0 mt-2 md:mt-4 md:text-6xl">{{ loan.amount | money(0) }}</h2>
          </div>
          <div class="flex-initial">
            <i class="fa fa-check-circle text-success text-7xl"/>
          </div>
        </div>
      </template>
    </app-header>

    <app-body medium-max-width="max-w-500" footer>
      <template #title>
        Verify Identity In Process...
      </template>

      <template #text>
        <div>
          <div class="flex items-center mb-3">
            <i class="fa fa-info-circle text-info text-2xl"/>
            <p class="ml-2">This can take some time</p>
          </div>
        </div>
      </template>

      <template #main>
        <WaitingProgressBar
            :show-progress="true"
            :progressDuration="90"
            :progressTexts="[
              'Starting identity verification...',
              'Collecting personal information...',
              'Verifying identity documents...',
              'Validating records...',
              'Finalizing verification...',
              'Awaiting decision...'
            ]"
        />
      </template>
    </app-body>
  </app-wrapper>
</template>

<script>
import AppLogo from './../../../components/AppLogo';
import WaitingProgressBar from '../../../components/WaitingProgressBar.vue';

export default {
  mixins: [require('../../../mixins/InteractsWithGtag').default],
  components: {
    AppLogo,
    WaitingProgressBar,
  },
  props: {
    user: {},
    loan: {},
    manual: {
      type: Boolean,
      default: false,
    }
  },

  data() {
    return {
      gTagPageName: 'verify-identity-processing',

    };
  },

  created() {
  },

  methods: {

  },
};
</script>